export default __webpack_public_path__ + "static/media/printer-check.4e39c237.png";